'use strict';

module.exports = {
    DELIVERY_CREATED: 'delivery.state.created',
    DELIVERY_IN_PROGRESS: 'delivery.state.inProgress',
    DELIVERY_QUEUED: 'delivery.state.queued',
    DELIVERY_SCHEDULED: 'delivery.state.scheduled',
    DELIVERY_COMPLETED: 'delivery.state.completed',
    DELIVERY_FAILED: 'delivery.state.failed',
    DELIVERY_TRACKING_FOLDER_MONITOR_UPDATE: 'delivery.tracking.folderMonitor.update',
    DELIVERY_TRACKING_EXECUTION_UPDATE: 'delivery.tracking.execution.update',
    DELIVERY_TRACKING_BACKLOG_UPDATE: 'delivery.tracking.backlog.update',
    DELIVERY_BATCH_QUEUED: 'deliveryBatch.state.queued',
    DELIVERY_BATCH_SCHEDULED: 'deliveryBatch.state.scheduled',
    DELIVERY_BATCH_IN_PROGRESS: 'deliveryBatch.state.inProgress',
    DELIVERY_BATCH_COMPLETED: 'deliveryBatch.state.completed',
    DELIVERY_BATCH_FAILED: 'deliveryBatch.state.failed',
    DELIVERY_BATCH_STATES_UPDATE: 'delivery.batchStates.update'
};